import { SERVER_API } from 'SharedDir/constants/app/endpoints';

const nomenclatureCatalogsUrl = `${SERVER_API}/ttp-registries`;

export const mtsTypeUrl = `${nomenclatureCatalogsUrl}/mts-type`;

export const nationUrl = `${nomenclatureCatalogsUrl}/nation`;

export const subsurfaceUserUrl = `${SERVER_API}/thd-registries/subsurface-user`;
export const licenseAreUrl = `${SERVER_API}/thd-registries/license-area`;
export const thdBuildingUrl = `${SERVER_API}/thd-registries/building`;
